module.exports = __webpack_public_path__ + "static/savings-her-8f391a522d7e17bab7ba4057d7305301.png";